<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs12 md8 offset-md2>
          <v-card flat class="card--flex-toolbar" color="transparent">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2 class="white--text">Kontakt</h2>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg10 v-for="item in links" :key="item.id">
                  <v-hover>
                    <v-card
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 12 : 2}`"
                    >
                      <v-img
                        src=""
                        aspect-ratio="2.75"
                        height="125px"
                        :class="item.color"
                      ></v-img>

                      <v-card-title primary-title>
                        <div>
                          <h3 class="headline mb-0">{{ item.title }}</h3>
                          <div>
                            {{ item.description }}<b>{{ item.name }}</b>
                          </div>
                          <div>
                            <div>
                              <b>{{ item.name }}</b>
                            </div>
                            <div>
                              <b>{{ item.street }}</b>
                            </div>
                            <div>
                              <b>{{ item.city }}</b>
                            </div>
                            <div>
                              <b>{{ item.email }}</b>
                            </div>
                            <div>
                              <b>{{ item.mobile }}</b>
                            </div>
                          </div>
                        </div>
                      </v-card-title>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          id: "1",
          color: "primary-color-bg",
          title: "Akademia Testera",
          description: "Akademia Testera jest częścią ",
          name: "D4 Group",
          street: "Sokołowice 117A",
          city: " 56-400 Oleśnica",
          email: "biuro.d4@gmail.com",
          mobile: "607412031 - Tomasz Diakowski",
        },
      ],
    };
  },
};
</script>

<style scoped>
.outine-2 {
  border: 2px solid white;
}

.card--flex-toolbar {
  margin-top: -124px;
}

.learn-more-btn {
  text-transform: initial;
  text-decoration: underline;
}
</style>
